// Feature mapping with actual feature groups
export const FEATURE_MAPPING = {
    CD_LAG_FEATURES: [
        'w1d_site_units_sum',
        'w1d_site_orders_sum',
        'w7d_site_units_sum',
        'w7d_site_orders_sum',
        'w14d_site_units_sum',
        'w14d_site_orders_sum',
        'w21d_site_units_sum',
        'w21d_site_orders_sum',
        'w28d_site_units_sum',
        'w28d_site_orders_sum',
        'w70d_site_units_sum',
        'w70d_site_orders_sum',
        'w1d_site_units_mean',
        'w1d_site_orders_mean',
        'w7d_site_units_mean',
        'w7d_site_orders_mean',
        'w14d_site_units_mean',
        'w14d_site_orders_mean',
        'w21d_site_units_mean',
        'w21d_site_orders_mean',
        'w28d_site_units_mean',
        'w28d_site_orders_mean',
        'w70d_site_units_mean',
        'w70d_site_orders_mean',
        'w28d_site_segment_N0_Y_units_sum',
        'w28d_site_segment_N0_Y_orders_sum',
        'w28d_site_segment_N1_Y_units_sum',
        'w28d_site_segment_N1_Y_orders_sum',
        'w28d_site_segment_N2_Y_units_sum',
        'w28d_site_segment_N2_Y_orders_sum',
        'w28d_site_segment_N3_Y_units_sum',
        'w28d_site_segment_N3_Y_orders_sum',
        'w28d_site_segment_N4_Y_units_sum',
        'w28d_site_segment_N4_Y_orders_sum',
        'w28d_site_segment_N5_Y_units_sum',
        'w28d_site_segment_N5_Y_orders_sum',
        'w70d_site_segment_N0_Y_units_sum',
        'w70d_site_segment_N0_Y_orders_sum',
        'w70d_site_segment_N1_Y_units_sum',
        'w70d_site_segment_N1_Y_orders_sum',
        'w70d_site_segment_N2_Y_units_sum',
        'w70d_site_segment_N2_Y_orders_sum',
        'w70d_site_segment_N3_Y_units_sum',
        'w70d_site_segment_N3_Y_orders_sum',
        'w70d_site_segment_N4_Y_units_sum',
        'w70d_site_segment_N4_Y_orders_sum',
        'w70d_site_segment_N5_Y_units_sum',
        'w70d_site_segment_N5_Y_orders_sum',
        'w28d_site_segment_N0_N_units_sum',
        'w28d_site_segment_N0_N_orders_sum',
        'w28d_site_segment_N1_N_units_sum',
        'w28d_site_segment_N1_N_orders_sum',
        'w28d_site_segment_N2_N_units_sum',
        'w28d_site_segment_N2_N_orders_sum',
        'w28d_site_segment_N3_N_units_sum',
        'w28d_site_segment_N3_N_orders_sum',
        'w28d_site_segment_N4_N_units_sum',
        'w28d_site_segment_N4_N_orders_sum',
        'w28d_site_segment_N5_N_units_sum',
        'w28d_site_segment_N5_N_orders_sum',
        'w70d_site_segment_N0_N_units_sum',
        'w70d_site_segment_N0_N_orders_sum',
        'w70d_site_segment_N1_N_units_sum',
        'w70d_site_segment_N1_N_orders_sum',
        'w70d_site_segment_N2_N_units_sum',
        'w70d_site_segment_N2_N_orders_sum',
        'w70d_site_segment_N3_N_units_sum',
        'w70d_site_segment_N3_N_orders_sum',
        'w70d_site_segment_N4_N_units_sum',
        'w70d_site_segment_N4_N_orders_sum',
        'w70d_site_segment_N5_N_units_sum',
        'w70d_site_segment_N5_N_orders_sum',
        'w28d_site_segment_N0_Y_units_mean',
        'w28d_site_segment_N0_Y_orders_mean',
        'w28d_site_segment_N1_Y_units_mean',
        'w28d_site_segment_N1_Y_orders_mean',
        'w28d_site_segment_N2_Y_units_mean',
        'w28d_site_segment_N2_Y_orders_mean',
        'w28d_site_segment_N3_Y_units_mean',
        'w28d_site_segment_N3_Y_orders_mean',
        'w28d_site_segment_N4_Y_units_mean',
        'w28d_site_segment_N4_Y_orders_mean',
        'w28d_site_segment_N5_Y_units_mean',
        'w28d_site_segment_N5_Y_orders_mean',
        'w70d_site_segment_N0_Y_units_mean',
        'w70d_site_segment_N0_Y_orders_mean',
        'w70d_site_segment_N1_Y_units_mean',
        'w70d_site_segment_N1_Y_orders_mean',
        'w70d_site_segment_N2_Y_units_mean',
        'w70d_site_segment_N2_Y_orders_mean',
        'w70d_site_segment_N3_Y_units_mean',
        'w70d_site_segment_N3_Y_orders_mean',
        'w70d_site_segment_N4_Y_units_mean',
        'w70d_site_segment_N4_Y_orders_mean',
        'w70d_site_segment_N5_Y_units_mean',
        'w70d_site_segment_N5_Y_orders_mean',
        'w28d_site_segment_N0_N_units_mean',
        'w28d_site_segment_N0_N_orders_mean',
        'w28d_site_segment_N1_N_units_mean',
        'w28d_site_segment_N1_N_orders_mean',
        'w28d_site_segment_N2_N_units_mean',
        'w28d_site_segment_N2_N_orders_mean',
        'w28d_site_segment_N3_N_units_mean',
        'w28d_site_segment_N3_N_orders_mean',
        'w28d_site_segment_N4_N_units_mean',
        'w28d_site_segment_N4_N_orders_mean',
        'w28d_site_segment_N5_N_units_mean',
        'w28d_site_segment_N5_N_orders_mean',
        'w70d_site_segment_N0_N_units_mean',
        'w70d_site_segment_N0_N_orders_mean',
        'w70d_site_segment_N1_N_units_mean',
        'w70d_site_segment_N1_N_orders_mean',
        'w70d_site_segment_N2_N_units_mean',
        'w70d_site_segment_N2_N_orders_mean',
        'w70d_site_segment_N3_N_units_mean',
        'w70d_site_segment_N3_N_orders_mean',
        'w70d_site_segment_N4_N_units_mean',
        'w70d_site_segment_N4_N_orders_mean',
        'w70d_site_segment_N5_N_units_mean',
        'w70d_site_segment_N5_N_orders_mean',
        'w28d_site_segment_N0_units_sum',
        'w28d_site_segment_N0_orders_sum',
        'w28d_site_segment_N1_units_sum',
        'w28d_site_segment_N1_orders_sum',
        'w28d_site_segment_N2_units_sum',
        'w28d_site_segment_N2_orders_sum',
        'w28d_site_segment_N3_units_sum',
        'w28d_site_segment_N3_orders_sum',
        'w28d_site_segment_N4_units_sum',
        'w28d_site_segment_N4_orders_sum',
        'w28d_site_segment_N5_units_sum',
        'w28d_site_segment_N5_orders_sum',
        'w70d_site_segment_N0_units_sum',
        'w70d_site_segment_N0_orders_sum',
        'w70d_site_segment_N1_units_sum',
        'w70d_site_segment_N1_orders_sum',
        'w70d_site_segment_N2_units_sum',
        'w70d_site_segment_N2_orders_sum',
        'w70d_site_segment_N3_units_sum',
        'w70d_site_segment_N3_orders_sum',
        'w70d_site_segment_N4_units_sum',
        'w70d_site_segment_N4_orders_sum',
        'w70d_site_segment_N5_units_sum',
        'w70d_site_segment_N5_orders_sum',
        'w28d_site_segment_N0_units_mean',
        'w28d_site_segment_N0_orders_mean',
        'w28d_site_segment_N1_units_mean',
        'w28d_site_segment_N1_orders_mean',
        'w28d_site_segment_N2_units_mean',
        'w28d_site_segment_N2_orders_mean',
        'w28d_site_segment_N3_units_mean',
        'w28d_site_segment_N3_orders_mean',
        'w28d_site_segment_N4_units_mean',
        'w28d_site_segment_N4_orders_mean',
        'w28d_site_segment_N5_units_mean',
        'w28d_site_segment_N5_orders_mean',
        'w70d_site_segment_N0_units_mean',
        'w70d_site_segment_N0_orders_mean',
        'w70d_site_segment_N1_units_mean',
        'w70d_site_segment_N1_orders_mean',
        'w70d_site_segment_N2_units_mean',
        'w70d_site_segment_N2_orders_mean',
        'w70d_site_segment_N3_units_mean',
        'w70d_site_segment_N3_orders_mean',
        'w70d_site_segment_N4_units_mean',
        'w70d_site_segment_N4_orders_mean',
        'w70d_site_segment_N5_units_mean',
        'w70d_site_segment_N5_orders_mean',
        'w1_site_dow_units_sum',
        'w1_site_dow_orders_sum',
        'w2_site_dow_units_sum',
        'w2_site_dow_orders_sum',
        'w3_site_dow_units_sum',
        'w3_site_dow_orders_sum',
        'w4_site_dow_units_sum',
        'w4_site_dow_orders_sum',
        'w1_site_dow_units_value',
        'w1_site_dow_orders_value',
        'w2_site_dow_units_value',
        'w2_site_dow_orders_value',
        'w3_site_dow_units_value',
        'w3_site_dow_orders_value',
        'w4_site_dow_units_value',
        'w4_site_dow_orders_value',
        'y1_site_units_value',
        'y1_site_orders_value',
    ],
    MONTHLY_PATTERNS: [
        'monthly-basis-0',
        'monthly-basis-1',
        'monthly-basis-2',
        'monthly-basis-3',
        'monthly-basis-4',
        'monthly-basis-5',
        'monthly-basis-6',
        'monthly-basis-7',
        'dom',
        'f7d_of_mon',
        'l7d_of_mon',
        'wom',
    ],
    HOLIDAY_FEATURES: [
        'Black_Friday',
        'Christmas',
        'Christmas_Eve',
        'Columbus_Day',
        'Cyber_Monday',
        'Day_After_Christmas',
        'Easter',
        "Father's_Day",
        'Halloween',
        'HolidayWeekendFriday',
        'HolidayWeekendMonday',
        'HolidayWeekendSaturday',
        'HolidayWeekendSunday',
        'Independence_Day',
        'Labor_Day',
        'MLK_Jr._Day',
        'Memorial_Day',
        'MidweekHoliday',
        'MidweekHolidayAdjacent',
        "Mother's_Day",
        "New_Year's_Day",
        "New_Year's_Eve",
        'Prime_Day',
        "St._Patrick's_Day",
        'StoreClosure',
        'Super_Bowl',
        'Thanksgiving',
        "Valentine's_Day",
        'Veterans_Day',
        "Washington's_Birthday",
        'is_holiday_week',
        'any_holiday_last_week',
    ],
    NODE: ['node'],
    BUSINESS: ['business'],
    STATE: ['state'],
    WEEKLY_PATTERNS: ['dow'],
    YEARLY_PATTERNS: ['woy', 'doy', 'year', 'month'],
    PAPAYA_FST_FLAG: ['papaya_FST_flag'],
    LOWER_FST_FLAG: ['lower_FST_flag'],
    SUBSCRIPTION_FLAG: ['subscription_flag'],
    SNAP_DIST_FEATURES: ['snap_dist_flag', 'snap_l3_days', 'snap_l7_days'],
};
